import React from 'react';
import { Image } from '@wix/design-system';
import { useResizeImage } from '../../hooks/image-resize';

export function AppIcon({
  iconUrl,
  appName,
  className,
}: {
  iconUrl: string;
  appName: string;
  className: string;
}) {
  const resizeImage = useResizeImage();
  return (
    <Image
      height="42px"
      width="42px"
      alt={`${appName} icon`}
      src={resizeImage({
        imageUrl: iconUrl,
        originalHeight: 974,
        originalWidth: 974,
        toHeight: 42,
        toWidth: 42,
      })}
      className={className}
    />
  );
}
